'use client'

import { createContext, useMemo, type ReactNode } from 'react'
import type { ObservabilityMethods } from '../types'
import { createFaroLogMethods } from './adapters/faro'

const noopMethods: ObservabilityMethods = {
    logWarning: () => {},
    logError: () => {},
    logMeasurement: () => {}
}

export const ObservabilityContext = createContext<ObservabilityMethods>(noopMethods)

/**
 * Publishes the log methods to the tree.
 *
 * It starts nothing. `initializeObservability` runs from the app's
 * `instrumentation-client.ts`, before React hydrates. The methods below read
 * the Faro module singleton, so they work whether or not that call ran, and
 * they drop what they are given until it does.
 */
export function ObservabilityProvider({ children }: { children: ReactNode }) {
    const methods = useMemo(() => createFaroLogMethods(), [])

    return <ObservabilityContext.Provider value={methods}>{children}</ObservabilityContext.Provider>
}
